'use strict';

angular.module('amexReconciliationApp')
  .service('Meetings360ThirdPartyDataRepository',
  function Meetings360ThirdPartyDataRepository($resource) {
    var self = this;
    var meeting360ThirdPartyDataResource =
      $resource('/api/v1/transactions/:transactionId/meetings360-third-party-data');

    self.getMeeting360ThirdPartyData = function getMeeting360ThirdPartyData(transactionId) {
      return meeting360ThirdPartyDataResource
        .get({transactionId: transactionId})
        .$promise
        .then(function (response) {
          return response.toJSON();
        })
        .catch(function () {
          return {};
        });
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/Meeting360ThirdPartyDataRepostitory.js
// module id = 612
// module chunks = 0